export { default, type EmptyStateProps } from './EmptyState';
